import React, { useState } from 'react';
import { Grid, Typography, TextField, Modal, Button, Box } from '@mui/material';
import { useApiSend } from '../../utils/httpClient';
import { createMessage } from '../../endpoints/resources';
import { LoadingButton } from '@mui/lab';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 650,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
};

export default function MessageCreate({
  modalOpen,
  setModalOpen,
  id,
  name,
  toType,
  screenName,
}) {
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const { mutate } = useApiSend(
    createMessage,
    (data) => {
      setIsSaving(false);
      setMessage('');
      setModalOpen(false);
    },
    (error) => {
      setError(
        error.message
          ? error.message
          : 'Error submitting request, if problem persists, please contact support'
      );
      setIsSaving(false);
    }
  );

  const sendMessage = () => {
    setError(null);

    if (!message) {
      setError('Message cannot be empty');
      return;
    }
    // make sure message is not longer than 2000 characters
    if (message.length > 2000) {
      setError('Message cannot be longer than 2000 characters');
      return;
    }
    // make sure message is not empty
    if (message.length === 0) {
      setError('Message cannot be empty');
      return;
    }

    setIsSaving(true);
    mutate({
      to_id: id,
      to_type: toType,
      name: name,
      message: message,
      screen_name: screenName,
    });
  };
  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby="create-message-modal"
      aria-describedby="create-message-description"
    >
      <Box sx={style}>
        <Grid container>
          <Grid item xs={12} textAlign={'center'} padding>
            <Typography variant="h4">Create Message</Typography>
          </Grid>
          <Grid item xs={12} padding>
            <Typography variant="body1">
              <b>To:</b> {name}
            </Typography>
          </Grid>
          <Grid item xs={12} padding>
            <TextField
              fullWidth
              label="Message"
              variant="outlined"
              size="small"
              multiline
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} padding textAlign={'center'}>
            <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
              Your message may be subject to review. Please ensure it adheres to
              our community guidelines.
            </Typography>
          </Grid>
          <Grid item xs={12} padding textAlign={'right'}>
            <Button
              variant="outlined"
              color="warning"
              size="small"
              onClick={() => setModalOpen(false)}
            >
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              size="small"
              loading={isSaving}
              disabled={isSaving}
              onClick={() => {
                // Handle send message logic here
                sendMessage();
              }}
            >
              Send Message
            </LoadingButton>
          </Grid>
          <Grid item xs={12} padding textAlign={'center'}>
            {error && (
              <Typography variant="body1" color="error">
                {error}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
